<script setup lang="ts">
  defineOptions({ name: 'ExhibitorCenterMobileNavEntry' })

  import { useI18n } from 'vue-i18n'

  import { ChevronRightIcon, Building07Icon } from '@gohighlevel/ghl-icons/24/outline'

  import { createElementId } from '@common/core-layer/utils'

  import { useSidebarDrawer } from '@common/shared-ui-layer/composables/useSidebarDrawer'

  import CPText from '@ui/components/CPText.vue'

  import { useExhibitorAdminContext } from '../../composables/useExhibitorAdminContext'

  const { t } = useI18n()
  const { close: closeSidebarDrawer } = useSidebarDrawer()
  const { goToCenter } = useExhibitorAdminContext()

  /**
   * The drawer is unmounted on the exhibitor center itself, so this row is one-way: close first,
   * then navigate, or the drawer's own unmount would race the transition.
   */
  const handleClick = async () => {
    closeSidebarDrawer()
    await goToCenter()
  }
</script>

<template>
  <div
    :id="createElementId('exhibitor-center', 'mobile-nav', 'entry')"
    class="flex min-h-10 w-full min-w-0 cursor-pointer items-center gap-2 px-4 py-2 hover:bg-hover active:bg-hover"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <Building07Icon class="h-4 w-4 flex-shrink-0 text-body" aria-hidden="true" />
    <CPText size="lg" weight="medium" html-tag="span" class="min-w-0 flex-1 truncate text-body">
      {{ t('clientportal.events.detail.exhibitorCenterToggleCenter') }}
    </CPText>
    <ChevronRightIcon class="h-5 w-5 flex-shrink-0 text-muted" aria-hidden="true" />
  </div>
</template>
